import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=05fafa5a&scoped=true&"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts&"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=05fafa5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fafa5a",
  null
  
)

export default component.exports